﻿import { Component } from '@angular/core';
import { Tabla } from '../../tabla';

@Component({ template:  `
    <app-tabla [tabla]="tabla"></app-tabla>
` })
export class PuestoUserComponent {

    tabla: Tabla = {
        titulo: 'Puestos',
        endPoint:'/rest-api/user/puesto',
        editable: true,
        columnas: [
            {
                name: 'ID',
                prop: 'id',
                editable: false,
                resizeable: true,
                sortable: true,
                width: 150
            },
            {
                name: 'Nombre',
                prop: 'nombre',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 300
            },
            {
                name: 'Puntos',
                prop: 'puntos',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 100
            }

        ]
    };

}
